import { Performer } from '../core/performer'
import { HttpMethod } from '../core/types'

class ResendFirstTestDryRun extends Performer<
  {
    payload: {
      from?: string
      to?: string
      language?: string
    }
  },
  { total: number }
> {
  protected method = HttpMethod.GET
  protected url = '/assessment/resend-first-test/dry-run'
}

class ResendFirstTestExecute extends Performer<
  {
    payload: {
      from?: string
      to?: string
      language?: string
    }
  },
  { total: number; sent: number; failed: number }
> {
  protected method = HttpMethod.POST
  protected url = '/assessment/resend-first-test'
}

export const resendFirstTestApi = {
  dryRun: new ResendFirstTestDryRun().perform,
  execute: new ResendFirstTestExecute().perform,
}
